// Reducers needed for admin section (only used in "main" app)

import { appReducer as app } from "metabase/admin/app/reducers";
import { databasesReducer as databases } from "metabase/admin/databases/database";
import { datamodel } from "metabase/admin/datamodel/datamodel";
import { people } from "metabase/admin/people/people";
import { permissions } from "metabase/permissions";
import { combineReducers } from "metabase/redux";

export const admin = combineReducers({
  app,
  databases,
  datamodel,
  people,
  permissions,
});
